module.exports = __webpack_public_path__ + "img/about_icone_3.6.c1fde1a1.webp";